import { moveExploreFieldTo } from "/explore_field_functions/movement_functions.js";

let selectedExplore = null;
let xDifference = 0,
    yDifference = 0;


const excludedListByClass = ['explore-window-branch', 'explore-window-branch-reveal-children', 'explore-zoom-controller'];

export function mouseDownDragExplore(e) {
    e.preventDefault();
    const elements = document.elementsFromPoint(e.clientX, e.clientY);
    
    if(!checkIfElementsBelowContainClasses(elements)) {
        e.preventDefault();
        selectedExplore = findFirstExploreInElements(document.elementsFromPoint(e.clientX, e.clientY));

        xDifference = e.clientX - selectedExplore.offsetLeft;
        yDifference = e.clientY - selectedExplore.offsetTop;
    }
    
}

export function mouseMoveDragExplore(e) {
    if(selectedExplore!==null) {
        const leftPos = e.clientX - xDifference;
        const topPos = e.clientY - yDifference;

        const exploreWrapper = selectedExplore.parentElement;

        selectedExplore.moveExploreFieldTo(-leftPos, -topPos);
        
    }
}

export function mouseUpDragExplore(e) {
    if(selectedExplore!==null) {
        selectedExplore=null;
    }
}

function findFirstExploreInElements(elements) {
    let element = null;

    for(let i of elements) {
        if(i.classList.contains('explore-general-field')) {
            element = i;
        }
    }

    return element;
}

function checkIfElementsBelowContainClasses(elements) {
    for(let i of elements) {
        for(let j of excludedListByClass) {
            if(i.classList.contains(j))
                return true;
        }
    }
}